<template>
  <div
    class="bg-ontick-carbon-900 fixed inset-0 z-40 flex items-center justify-center bg-opacity-60"
    @click.self="$emit('close')"
  >
    <div class="bg-ontick-graphite-500 relative flex w-[600px] flex-col rounded-[32px] gap-8 items-center p-8">
      <!-- ============================= -->

      <button
        class="absolute top-6 right-6 cursor-pointer bg-ontick-carbon-600 p-2 rounded-full"
        @click="$emit('close')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.244078 0.244078C0.569515 -0.0813592 1.09715 -0.0813592 1.42259 0.244078L5 3.82149L8.57741 0.244078C8.90285 -0.0813592 9.43049 -0.0813592 9.75592 0.244078C10.0814 0.569515 10.0814 1.09715 9.75592 1.42259L6.17851 5L9.75592 8.57741C10.0814 8.90285 10.0814 9.43049 9.75592 9.75592C9.43049 10.0814 8.90285 10.0814 8.57741 9.75592L5 6.17851L1.42259 9.75592C1.09715 10.0814 0.569515 10.0814 0.244078 9.75592C-0.0813592 9.43049 -0.0813592 8.90285 0.244078 8.57741L3.82149 5L0.244078 1.42259C-0.0813592 1.09715 -0.0813592 0.569515 0.244078 0.244078Z"
            fill="#9CA3AF"
          />
        </svg>
      </button>

      <!-- ============================= -->
      <div class="flex flex-col items-center gap-6 text-center mt-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="84" height="74" viewBox="0 0 84 74" fill="none">
          <path
            d="M9.36987 73.6992H74.6299C81.3032 73.6992 85.4632 66.4625 82.1265 60.6992L49.4965 4.3225C46.1599 -1.44083 37.8399 -1.44083 34.5032 4.3225L1.87321 60.6992C-1.46346 66.4625 2.69654 73.6992 9.36987 73.6992ZM41.9999 43.3658C39.6165 43.3658 37.6665 41.4158 37.6665 39.0325V30.3658C37.6665 27.9825 39.6165 26.0325 41.9999 26.0325C44.3832 26.0325 46.3332 27.9825 46.3332 30.3658V39.0325C46.3332 41.4158 44.3832 43.3658 41.9999 43.3658ZM46.3332 60.6992H37.6665V52.0325H46.3332V60.6992Z"
            fill="#D7C94E"
          />
        </svg>
        <p class="font-bold text-3xl">Parar Trade Ideas</p>
      </div>
      <!-- ============================= -->

      <p class="text-base font-normal text-gray-300">
        Ao confirmar esta ação todas as Trade Ideas do parceiro<br />
        <strong class="font-semibold text-gray-50">[Nome do parceiro]</strong> serão encerradas. Trade Ideas
        <br />encerradas desta forma não poderão ser religadas.
      </p>

      <p class="text-base font-normal text-ontick-yellow-700">
        Atenção! Esta ação <strong class="font-semibold">NÃO</strong> impede que novas Trade Ideas<br />iniciem
        automaticamente através da pré-autorização.
      </p>

      <!-- ============================= -->

      <div class="w-[80%] h-[2px] bg-ontick-steel-500"></div>

      <!-- ============================= -->

      <div class="flex flex-col w-full gap-3">
        <p class="text-center text-base font-normal text-gray-400">
          Para cancelar esta pré autorização digite<br />a palavra
          <strong class="font-semibold text-gray-50">CONFIRMAR</strong> no campo abaixo.
        </p>

        <input
          type="text"
          ref="inputConfirm"
          v-model="inputConfirm"
          class="uppercase bg-ontick-carbon-500 text-lg text-gray-400 w-full rounded-md border-none focus:outline-none focus:ring-0 text-center"
          maxlength="30"
        />

        <button
          @click="$emit('confirm')"
          class="bg-ontick-red-700 mt-3 font-semibold py-2 w-full rounded-md filter hover:brightness-125 transition-all disabled:filter-none disabled:bg-gray-500 flex items-center justify-center cursor-pointer disabled:cursor-not-allowed"
          :disabled="inputConfirm.toUpperCase() !== 'CONFIRMAR'"
        >
          <!-- <i v-html="$icons.loading" v-if="loading"></i> -->
          <span class="text-lg">Encerrar trade idea</span>
        </button>
      </div>

      <!-- ============================= -->
    </div>
  </div>
</template>

<script>
import OntickBrokerLogoComponent from "../../../shared/components/basic/ontick-broker-logo.component.vue";

export default {
  name: "ModalStopStrategy",

  components: {
    OntickBrokerLogoComponent,
  },

  data() {
    return {
      inputConfirm: "",
      iconCheck: `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
          <path
            d="M3.99993 7.80007L1.19993 5.00006L0.266602 5.9334L3.99993 9.66673L11.9999 1.66673L11.0666 0.733398L3.99993 7.80007Z"
            fill="#19D684"
          />
        </svg>
      `,
    };
  },

  mounted() {
    this.$refs.inputConfirm.focus();
  },
};
</script>

<style lang="scss" scoped></style>
